import moment from "moment";

export const resolvePaymentTerms = (paymentTerms, { fromDateString }) => {
  if (!paymentTerms) {
    return null;
  }

  if (paymentTerms.days != null) {
    const fromDate = moment.parseZone(fromDateString);
    const paymentTermsDueDateString = fromDate.isValid()
      ? fromDate.add(paymentTerms.days, "day").format("YYYY-MM-DD")
      : null;
    return {
      ...paymentTerms,
      dueDate: paymentTermsDueDateString,
    };
  } else {
    return paymentTerms;
  }
};
